import axiosCommon from '@/api/axiosCommon'
// import { getCookie } from '@/common/utils'
// const LOGS = {
// }
let logs = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 查询日志信息
    async getLogs({
      commit
    }, payload) {
      let result = await axiosCommon.post(
        '/rest/log/getOperateLogList',
        payload
        )
        
      return result
    }
  }
}

export default logs